module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt7 mh3 mh4-ns"
  }, [_c('div', {
    staticClass: "mw8-ns center"
  }, [(this.$store.state.errors.length) ? _c('div', {
    staticClass: "tc"
  }, [_vm._v("\n      " + _vm._s(this.$store.state.errors[0]) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ce9ef4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirmation.vue
// module id = 503
// module chunks = 0